
import React, { useEffect,useCallback } from 'react'
import renderHTML from 'react-render-html'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import logo from '../../../utilities/images/zuver-logo.svg'
import Cart from '../../shared/cart'
import { getCartToken } from '../../../utilities/function/cartToken'
import { getDataFromURL } from '../../../utilities/function/urlparams'

import CheckoutHeader from './header'
import Account from './account'
import Payment from './payment'
import Finished from './finished'
import PayInvoice from './payinvoice'
import Paypal from './paypal'

import Loading from '../../../components/shared/loading'
import PayInvoiceWithRef from './payinvoice-withref'
import Switch from './switch'

let PageSelector = (props) => {
  const { location, history } = props
  const { a, step } = getDataFromURL(location.search)
  const { cartData, cartStatus } = useSelector(state => ({
    cartData: state.app.cartData,
    cartStatus: state.app.cartStatus
  }))

  const checkURLcallback = useCallback(()=>{
    if (!getCartToken()) {
      if (step !== 'payinvoice' && a !== 'pay'
        && step !== 'finished' && step !== 'paypal'
        && a !=="switch"
      ) {
        history.push(history.location.pathname)
      }
    }
  },[history, step, a])

  const checkCartCallback = useCallback(()=>{
    if (cartStatus === 'success' && cartData && cartData.items.length === 0 && a !=="switch") {
      window.setTimeout(() => {
        history.push(history.location.pathname)
      }, 300)
    }
  },[cartData, cartStatus, history,a])

  useEffect(() => {
    checkURLcallback()
    checkCartCallback()
  }, [checkURLcallback,checkCartCallback])


  if (a === 'checkout') {
    if (step) {
      const renderCheckoutPage = () => {
        switch (step) {
          case 'account':
            return (<Account/>)
          case 'payment':
            return (<Payment/>)
          case 'finished':
            return (<Finished/>)
          case 'payinvoice':
            return (<PayInvoice/>)
          case 'paypal':
            return (<Paypal/>)
          default:
            return (<></>)
        }
      }
      return (
        <div className={`of-page of-checkout-page of-checkout-page--${step}`}>
          <CheckoutHeader/>
          {renderCheckoutPage()}
        </div>
      )
    }
    return (
      <Cart/>
    )
  } else if (a === 'pay') {
    switch (step) {
      case 'success':
      case 'payinvoice':
          return (<PayInvoiceWithRef/>)
      default:
        return (<></>)
    }
  } else if(a === 'switch'){
     return (
       <div className={`of-page of-switch-page of-checkout-page`}>
         <Switch/>
       </div>
     )
  }
  return (<></>)
}

PageSelector.propTypes = {
  location: PropTypes.any,
  history: PropTypes.any
}

PageSelector = withRouter(PageSelector)

let Checkout = () => {
  const {
    viewport,
    cartStatus
  } = useSelector(state => ({
      viewport: state.app.viewport,
      cartStatus: state.app.cartStatus
    }))
  const renderSidebar = () => {
    if (viewport !== 'xs') {
      const renderLogo = () => {
        if(window.app_config && window.app_config){
          const {company_logo} = window.app_config
          if(company_logo){
            return (
              <button className={'of-checkout-sidebar__logo-button'}><img className={'of-checkout-sidebar__logo of-checkout-sidebar__logo--custom'} src={company_logo}
                                                                          alt={`logo`}/></button>
            )
          }
        }
        return (<button className={'of-checkout-sidebar__logo-button'}><img className={'of-checkout-sidebar__logo'} src={logo}
                                                                            alt={`logo`}/></button>)
      }
      const renderDetails = () => {
          if(window.app_config && window.app_config){
            const {sidebar_featured} = window.app_config
            if(sidebar_featured){
              return (<div className={'of-checkout__sidebar-details checkout-sidebar-font-2-100'}>
                  {renderHTML(sidebar_featured)}
                </div>
              )
            }
          }
          return (<div className={`of-checkout-sidebar__details`}>
              <div className={'of-checkout-sidebar__heading checkout-sidebar-font-2-100'}>60 Day Money Back Guarantee</div>
              <div className={`of-checkout-sidebar__description checkout-sidebar-font-2-80`}>We`re so confident you`ll love our products, we`ll refund you the full amount any time over the next 60 days, no questions asked.</div>
              <ul className={'of-checkout-sidebar-list checkout-sidebar-font-2-100'}>
                <li className={'of-checkout-sidebar-list__item'}>
                  <div className={'of-checkout-sidebar-list__item-icon'}>
                    <i className={'icon icon-of-100-aus'}/>
                  </div>
                  <div className={'of-checkout-sidebar-list__item-details'}>
                    <div className={'of-checkout-sidebar-list__item-heading'}>100% Australian</div>
                    <div className={'of-checkout-sidebar-list__item-description checkout-sidebar-font-2-80'}>High performance hosting delivered from right here in Australia
                    </div>
                  </div>
                </li>
                <li className={'of-checkout-sidebar-list__item '}>
                  <div className={'of-checkout-sidebar-list__item-icon'}>
                    <i className={'icon icon-of-247-support'}/>
                  </div>
                  <div className={'of-checkout-sidebar-list__item-details'}>
                    <div className={'of-checkout-sidebar-list__item-heading'}>24x7 Local Support</div>
                    <div className={'of-checkout-sidebar-list__item-description checkout-sidebar-font-2-80'}>We`re here to support you 24 hours a day, 7 days a week
                    </div>
                  </div>
                </li>
                <li className={'of-checkout-sidebar-list__item '}>
                  <div className={'of-checkout-sidebar-list__item-icon'}>
                    <i className={'icon icon-of-uptime'}/>
                  </div>
                  <div className={'of-checkout-sidebar-list__item-details'}>
                    <div className={'of-checkout-sidebar-list__item-heading'}>99.9% Uptime Guarantee</div>
                    <div className={'of-checkout-sidebar-list__item-description checkout-sidebar-font-2-80'}>We keep your website is up and running around the clock
                    </div>
                  </div>
                </li>
              </ul>
            </div>)
      }
      return (
        <aside className='of-checkout__sidebar of-checkout-sidebar checkout-sidebar-background-1-100'>
          {renderLogo()}
          {renderDetails()}
        </aside>
      )
    }
    return (<></>)
  }

  const renderMain = () => {
    return (<div className='of-checkout__main of-checkout-main clearfix'>
      <PageSelector/>
    </div>)
  }

  return (<div className='of-checkout of-page'>
    {renderSidebar()}
    {renderMain()}
    {cartStatus === 'loading' ? <Loading wrapper={true}/> : <></>}
  </div>)
}

export default Checkout